<template>
    <Navbar />

    <slot></slot>

    <AppFooter />

    <FlashMessages v-if="flash" />

    <Wizard v-if="showWizard" />

    <Comparison v-if="comparisonList" />

    <CookieBanner v-if="!cookieConsentId" />
</template>

<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed, defineAsyncComponent, onMounted, onUnmounted, ref } from 'vue';

// Import components directly for critical components
import CookieBanner from '@/Components/CookieBanner.vue';
import AppFooter from '@/Layouts/Footer.vue';
import Navbar from '@/Layouts/Navbar.vue';
const inBrowser = typeof window !== 'undefined';

// Move cookieConsentId to computed property with browser check
const cookieConsentId = computed(() => (inBrowser ? window.cookieConsentId : 'fake-cookie-consent-id'));

// Lazy load non-critical components
const Comparison = defineAsyncComponent(() => import('@/Components/ComparisonList.vue'));
const FlashMessages = defineAsyncComponent(() => import('@/Components/FlashMessages.vue'));
const Wizard = defineAsyncComponent(() => import('@/Components/Wizard.vue'));

// Reactive state
const showWizard = ref(false);
const loaded = ref(false);

// Page props
const comparisonList = computed(() => usePage().props.comparisonList);
const flash = computed(() => usePage().props.flash);

defineProps({
    withoutContainer: Boolean,
});

onMounted(() => {
    // Setup event listeners
    setupEventListeners();
    loaded.value = true;
});

onUnmounted(() => {
    // Clean up event listeners
    if (inBrowser) {
        window.mitt.off('open-wizard', handleOpenWizard);
    }
});


function handleOpenWizard() {
    if (!inBrowser) return;
    showWizard.value = true;
}

// Setup functions
function setupEventListeners() {
    if (!inBrowser) return;

    window.mitt.on('open-wizard', handleOpenWizard);
}
</script>
